import { render, staticRenderFns } from "./PageParticipantConsent.vue?vue&type=template&id=6a5538e4&scoped=true&"
import script from "./PageParticipantConsent.vue?vue&type=script&lang=ts&"
export * from "./PageParticipantConsent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5538e4",
  null
  
)

export default component.exports